import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {icon && <div className="w-16 h-16 rounded-2xl bg-accent flex items-center justify-center mb-4 text-muted-foreground">
      {icon}
    </div>}
    <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
    {description && <p className="text-sm text-muted-foreground max-w-sm mb-6">{description}</p>}
    {action}
  </div>
);

export default EmptyState;
